import { createContext, useContext } from 'react';

type ActivityLogListItemContextValue = {
  isLastActivityLog: boolean;
  isFirstInAgentRun: boolean;
};

const ActivityLogListItemContext = createContext<ActivityLogListItemContextValue>({
  isLastActivityLog: false,
  isFirstInAgentRun: false,
});

export const ActivityLogListItemProvider = ActivityLogListItemContext.Provider;

export function useIsLastActivityLog(): boolean {
  return useContext(ActivityLogListItemContext).isLastActivityLog;
}

export function useIsFirstInAgentRun(): boolean {
  return useContext(ActivityLogListItemContext).isFirstInAgentRun;
}
